import { AIChatRequest, AIChatResponse, GDAIChatRequest, GDAIChatResponse } from '@/types';
import { buildAPIUrl, responseInterceptor } from '.';

export const gdAIchat = async (chatRequest: GDAIChatRequest): Promise<GDAIChatResponse> => {
  const resp = await responseInterceptor(
    await fetch(`${await buildAPIUrl()}/services/gdai/chat`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(chatRequest),
    }),
  );

  return resp.json();
};

export const gdAISummary = async (reportId: number): Promise<{ id: string; response: string }> => {
  const requestData = {
    id: `${reportId}-en_gb`,
  };

  const resp = await responseInterceptor(
    await fetch(`${await buildAPIUrl()}/services/gdai/summary`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData),
    }),
  );

  return resp.json();
};
